import { render, staticRenderFns } from "./DoctorAboutServiceForm.vue?vue&type=template&id=3bef53e0&"
import script from "./DoctorAboutServiceForm.vue?vue&type=script&lang=js&"
export * from "./DoctorAboutServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports